import { render } from "./NextStep.vue?vue&type=template&id=485912e3"
import script from "./NextStep.vue?vue&type=script&lang=js"
export * from "./NextStep.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__